import type { CoachMeta } from '@/lib/codebaby';
import { COACH } from '@/constants/coach';

/**
 * Renders the coach's `suggested_next_action` from the meta classifier as a
 * small inline CTA chip. When `meta` is null or has no suggestion, renders
 * nothing — keeping layout stable as classifications come and go.
 *
 * Click does nothing yet; in a follow-up we route the chip to an actual action
 * (e.g. navigate to a lesson, open a roleplay) by parsing the action string.
 */

export default function MetaCueChip({ meta }: { meta: CoachMeta | null }) {
  if (!meta?.suggested_next_action) return null;
  return (
    <button
      type="button"
      className={`meta-cue meta-cue--${meta.response_type}`}
      aria-label={`${COACH.firstName} suggests: ${meta.suggested_next_action}`}
    >
      <span className="meta-cue__eyebrow">{COACH.firstName} suggests</span>
      <span className="meta-cue__text">{meta.suggested_next_action}</span>
    </button>
  );
}
